<template>
  <div v-if="!loader" class="orientation column label wrap">
    <div class="row wrap">
      <div class="grid-6-s grid-3">
        Cliente
        <br />
        <strong>{{GET_JOB().nome_cliente}}</strong>
      </div>
      <div class="grid-6-s grid-5">
        Atendimento
        <br />
        <strong>{{GET_JOB().forma_atendimento}}</strong>
      </div>
      <div class="grid-6-s grid-4">
        Status
        <br />
        <strong>{{GET_JOB().status}}</strong>
      </div>
    </div>
    <div class="grid-12">
      Orientacoes
      <br />
      <strong>{{content.orientacoes}}</strong>
    </div>
    <div class="grid-12">
      Requerimentos
      <br />
      <strong>{{content.requerimento}}</strong>
    </div>
    <div class="grid-12">
      RAT
      <br />
      <strong>{{content.rat}}</strong>
    </div>
    <div class="row grid-12 justify-center">
      <div class="grid-4-g justify-center row">
        <Button
          layout="green-go"
          @click="modal.callback()"
          v-if="GET_JOB().status === 'Com Doutor'"
        >ESTOU ORIENTADO</Button>
        <Button layout="green-go" @click="modal.show = false" v-else>Fechar</Button>
      </div>
    </div>
  </div>
  <div v-else class="loader-container column align-center justify-center">
     <h1>Não deu certo</h1>
    <Loader />
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.orientation {
  padding-top: 25px;
  color: $gray-6;
  padding: 10px 30px;
  padding-top: 25px;
   padding-bottom: 25px;
  @media (min-width: $small) {
    /* width: 50%; */
    width: 600px;
  }
  .grid-12 {
    margin-top: 35px;
  }
  button {
    margin-top: 55px;
  }
  strong {
    font-weight: 500;
    color: $gray-1;
  }
}
.loader-container {
  margin-top: 40px;
  padding: 30px;
}
</style>

<script>
import Loader from "@/components/Loader";
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button";
export default {
  name: "Orientation_default",
  props: {
    modal: Object
  },
  components: {
    Button,
    Loader
  },
  data() {
    return {
      content: {},
      loader: true
    };
  },
  methods: {
    ...mapActions("job", ["LOAD_ORIENTATION_DEFAULT"]),
    ...mapGetters("job", ["GET_JOB"])
  },
  mounted() {
    const job = this.GET_JOB();
    if (job.id) {
      this.LOAD_ORIENTATION_DEFAULT().then(data => {
      
        this.loader = false;
        
        switch (job.forma_atendimento){
                case 'presencial':
                    
                    this.content = {
                        rat: data.rat_presencial,
                        requerimento: data.requerimento_presencial,
                        orientacoes: data.orientacao_presencial
                    }
                    break
                case 'remoto':
                    
                    this.content = {
                        rat: data.rat_remoto,
                        requerimento: data.requerimento_remoto,
                        orientacoes: data.orientacao_remoto
                    }
                    break
                
                default: this.orientacao_padrao = data
                
            }


      });
    } else {
      this.loader = false;
    }
  },
  computed: {}
};
</script>
